import { Modal, Button, Col, Row } from "react-bootstrap";
import { i18nValue } from '../functions';
import { T } from "react-translator-component";
import { isHostz, isHostzBecozy, isHostzBetaHouse, isHostzBlackSummit, isHostzSanCarlo } from "../components/CheckIn/hotelConditions";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock } from "@fortawesome/free-solid-svg-icons";

const InfoModal1 = ({ hotelId, hotelCode, checkIn, roomCode, language, placeholders, show, setShow }) => {

    const getPlaceholderValueFromCheckin = (phKey) => {
        const placeholders = { ...checkIn?.placeholders }
        let ph_value = '--'
        
        if (placeholders) {
            if (placeholders?.[phKey]) {
                const ph_values = placeholders[phKey];
                if (ph_values?.[language]) {
                    ph_value = ph_values[language];
                } else {
                    if (ph_values?.['en-US']) {
                        ph_value = ph_values['en-US'];
                    }
                }
            }
        }
        return ph_value
    }

    const stripStyles = (html) => {
        // Crear un contenedor temporal
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Eliminar etiquetas <style>
        const styles = tempDiv.querySelectorAll('style');
        styles.forEach((style) => style.remove());

        // Eliminar atributos style
        const elementsWithStyle = tempDiv.querySelectorAll('[style]');
        elementsWithStyle.forEach((el) => el.removeAttribute('style'));

        // Devolver el HTML limpio
        return tempDiv.innerHTML;
    };

    const isPlaceholderValid = (phKey) => {
        const placeholders = { ...checkIn?.placeholders }
        let isValid = false;
        if (placeholders) {
          if (placeholders?.[phKey]) {
            isValid = true;
          }
        }
        return isValid;
      }

    // const { data: hotel } = useContext(HotelContext)
    return (
        <>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                className={`info-modal info-modal-access hotel-${hotelCode}`}
            >
                <div className="modal-content-custom">
                    <Modal.Body className="modal-body-custom">
                        <div className="text-center p-4 mb-4">
                            <div>
                                <FontAwesomeIcon icon={faUnlock} color="#CCC" style={{ fontSize: 50, marginBottom: 30 }} />
                            </div>

                            {isHostz(hotelId) && (
                                <h3>{T("status.access_information")}</h3>
                            )}
                            {!isHostz(hotelId) && (
                                <h3>{T("status.access_code")}</h3>
                            )}


                            {isHostzBecozy(hotelId) && (
                                <>
                                    <span className="font-size-sm">{T("status.access_code.main_door")}</span>
                                    <h6 className="font-weight-bold font-size-lg">3749</h6>
                                    <span className="font-size-sm">{T("status.access_code.room_door")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-ACCESS-INFO') ? getPlaceholderValueFromCheckin('UNIT-ROOM-ACCESS-INFO') : getPlaceholderValueFromCheckin('ROOM-ACCESS-INFO') ) }}></h6>
                                    <br></br>
                                    <div className="font-size-sm">{T("status.access_code.hostz-becozy")}</div>
                                </>
                            )}

                            {isHostzBlackSummit(hotelId) && (
                                <p>
                                    <br></br>
                                    <span dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-ACCESS-INFO') ? getPlaceholderValueFromCheckin('UNIT-ROOM-ACCESS-INFO') : getPlaceholderValueFromCheckin('ROOM-ACCESS-INFO') ) }}></span>
                                </p>
                            )}

                            {isHostzSanCarlo(hotelId) && (
                                <>
                                    <span className="font-size-sm">{T("status.access_code.main_door")}</span>
                                    <h6 className="font-weight-bold font-size-lg">555666*</h6>
                                    <span className="font-size-sm">{T("status.access_code.key_collection_code")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-ACCESS-INFO') ? getPlaceholderValueFromCheckin('UNIT-ROOM-ACCESS-INFO') : getPlaceholderValueFromCheckin('ROOM-ACCESS-INFO') ) }}></h6>
                                    <span className="font-size-sm">{T("status.access_code.key_dropoff_code")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-DROPOFF-CODE') ? getPlaceholderValueFromCheckin('UNIT-ROOM-DROPOFF-CODE') : getPlaceholderValueFromCheckin('ROOM-DROPOFF-CODE') ) }}></h6>
                                </>
                            )}

                            {isHostzBetaHouse(hotelId) && (
                                <>
                                    <span className="font-size-sm">{T("status.access_code.key_collection_code")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-ACCESS-INFO') ? getPlaceholderValueFromCheckin('UNIT-ROOM-ACCESS-INFO') : getPlaceholderValueFromCheckin('ROOM-ACCESS-INFO') ) }}></h6>
                                    <span className="font-size-sm">{T("status.access_code.key_dropoff_code")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(isPlaceholderValid('UNIT-ROOM-DROPOFF-CODE') ? getPlaceholderValueFromCheckin('UNIT-ROOM-DROPOFF-CODE') : getPlaceholderValueFromCheckin('ROOM-DROPOFF-CODE') ) }}></h6>
                                    <span className="font-size-sm">{T("hotel.address")}</span>
                                    <h6 className="font-weight-bold font-size-lg" dangerouslySetInnerHTML={{ __html: stripStyles(getPlaceholderValueFromCheckin('UNITGROUP-ADDRESS')) }}></h6>
                                </>
                            )}

                        </div>
                    </Modal.Body>
                </div>
            </Modal >



        </>
    );
};

export default InfoModal1;
